import type { CommunityRole } from "../types/community";

export const isCommunityOwner = (
  communityId: string,
  roles?: CommunityRole[],
) => {
  if (!roles) return false;

  return roles.some(
    (role) => role.communityId === communityId && role.roleId === "1",
  );
};

export const isPlatformAdmin = (roles: string[]) => {
  if (!roles) return false;

  return roles.some((role) => role === "ADMIN");
};

/** Как показываем soft-deleted аккаунт вместо имени. */
export const DELETED_USER_NAME = "Удалённый аккаунт";

export type UserNameSource = {
  firstName?: string | null;
  lastName?: string | null;
  nickname?: string | null;
  isDeleted?: boolean | null;
};

/** "Имя Фамилия"; если оба поля пустые — никнейм; удалённый аккаунт — заглушка. */
export const getUserFullName = (user?: UserNameSource | null): string => {
  if (!user) return "";
  if (user.isDeleted) return DELETED_USER_NAME;

  const fullName = [user.firstName, user.lastName]
    .map((part) => part?.trim() ?? "")
    .filter(Boolean)
    .join(" ");

  return fullName || user.nickname?.trim() || "";
};
